module.exports = "<jhi-jumbotron>\n    <h1>Mises à jour du site</h1>\n</jhi-jumbotron>\n\n<div class=\"container\">\n    <jhi-changelog></jhi-changelog>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/footer/maj-site/maj-site.component.html
// module id = 811
// module chunks = 0